import { Image, Text, View } from '@react-pdf/renderer'

import { styles } from '../styles/styles'
import { ReportAttachmentIProps } from '../types/types'
import { getSplitImages } from '../utils/utils'

export const Attachments = ({ attachments, notes }: ReportAttachmentIProps) => {
  const { leftHalfImages, rightHalfImages } = getSplitImages(
    attachments.imageUrls,
    notes
  )
  const hasImages = leftHalfImages?.length > 0
  const { otherFileCount } = attachments

  if (!hasImages && !otherFileCount) {
    return null
  }

  return (
    <>
      <Text style={{ ...styles.mt5, ...styles.bold }}>Attachments</Text>

      {hasImages &&
        leftHalfImages.map((url: string, i: number) => {
          return (
            <View
              data-testid='incidentReport_attachment_image'
              key={i}
              style={styles.grid}
            >
              <View style={styles.imgBg}>
                <Image
                  cache={true}
                  src={{
                    uri: url,
                    method: 'GET',
                    headers: { 'Cache-Control': 'no-cache' },
                    body: '',
                  }}
                  style={styles.img}
                />
              </View>
              {rightHalfImages[i] && (
                <View style={styles.imgBg}>
                  <Image
                    cache={true}
                    src={{
                      uri: rightHalfImages[i],
                      method: 'GET',
                      headers: { 'Cache-Control': 'no-cache' },
                      body: '',
                    }}
                    style={styles.img}
                  />
                </View>
              )}
            </View>
          )
        })}

      {/* Non-image attachments cannot be rendered in the PDF and their original
          filenames are not stored, so they are reported as a count. */}
      {otherFileCount > 0 && (
        <Text data-testid='incidentReport_attachment_fileCount'>
          {otherFileCount === 1
            ? '1 additional file attached (not shown — view it in the incident)'
            : `${otherFileCount} additional files attached (not shown — view them in the incident)`}
        </Text>
      )}
    </>
  )
}
